import React from 'react';
import PropTypes from 'prop-types';
import ReactDOM from 'react-dom';

import useIsTouchDevice from '../hooks/useIsTouchDevice';
import CollectionQuery from './CollectionQuery';
import CollectionsList from '../containers/CollectionsList/CollectionsList';

var CollectionPage = function CollectionPage(props) {
  var isTouchDevice = useIsTouchDevice();

  if (props.dormifyCollectionsList) {
    if (props.showComingSoonImage) {
      return null;
    } else {
      return ReactDOM.createPortal(React.createElement(CollectionsList, {
        data: props.dormifyCollectionsList,
        pathName: props.location.pathname,
        addVariantToCart: props.addVariantToCart,
        checkout: props.checkout,
        collectionsBillboard: props.collectionsBillboard
      }), document.getElementById('react-collections-list'));
    }
  } else {
    return ReactDOM.createPortal(React.createElement(CollectionQuery, Object.assign({}, props, { isTouchDevice: isTouchDevice })), document.getElementById('react-collection'));
  }
};

CollectionPage.propTypes = {
  addVariantToCart: PropTypes.func.isRequired,
  navigate: PropTypes.func,
  checkout: PropTypes.object.isRequired,
  title: PropTypes.string,
  handle: PropTypes.string,
  location: PropTypes.object,
  handleCartOpen: PropTypes.func,
  wishlistProducts: PropTypes.array,
  customCollectionId: PropTypes.string,
  isCartOpen: PropTypes.bool,
  isTouchDevice: PropTypes.bool,
  hasMoreProductData: PropTypes.object,
  collectionProductCount: PropTypes.number,
  toggleAccountModal: PropTypes.func.isRequired,
  lowStockThreshold: PropTypes.string,
  dormifyXYouPage: PropTypes.bool
};

export default CollectionPage;